module.exports = __webpack_public_path__ + "light-repeating.svg?49ad792b08f36d4d99941c9b5196b8ec";